import type { FC } from "react";

import { Button, Card, Dialog } from "@eisox/design-system";
import { ArrowRightIcon, WarningIcon } from "@eisox/icons";

import { m } from "../../paraglide/messages";
import { descriptionForStatus, supportMailtoHref, SUPPORT_MAIL } from "../mutation-feedback.helper";
import type { ErrorDialogState } from "../mutation-feedback.type";

interface ErrorDialogProps {
  app: string;
  open: boolean;
  error: ErrorDialogState | null;
  onOpenChange: (open: boolean) => void;
}

const ErrorDialog: FC<ErrorDialogProps> = ({ app, open, error, onOpenChange }) => (
  <Dialog.Root open={open} onOpenChange={onOpenChange}>
    {error ? (
      <Dialog.Content
        className="gap-5 max-w-125"
        title={m.error_title()}
        icon={<WarningIcon className="text-primary-red!" />}
      >
        <Dialog.Description>{descriptionForStatus(error.status)}</Dialog.Description>
        {error.message ? (
          <Card className="overflow-y-auto bg-primary-gray text-base text-primary-dark-gray">
            <p className="wrap-anywhere">{error.message}</p>
          </Card>
        ) : null}
        <Dialog.Close asChild>
          <Button className="text-primary-dark-blue" asChild>
            <a href={supportMailtoHref(app, error)}>
              {m.send_details({ a: SUPPORT_MAIL })}
              <ArrowRightIcon />
            </a>
          </Button>
        </Dialog.Close>
      </Dialog.Content>
    ) : null}
  </Dialog.Root>
);

ErrorDialog.displayName = "ErrorDialog";

export { ErrorDialog };
